import type { FC, ReactNode } from 'react'
import type { City, DeliveryTier, GiftPackage } from '@/types'

import { ordersLive } from '@/lib/orders'
import CmsText from '@/components/generals/cms-text'
import InfoCard from '@/components/landing/info-card'
import OrderClosed from '@/components/landing/order-closed'
import OrderForm from '@/components/landing/order-form'
import { FadeIn } from '@/components/motion/fade-in'

interface OrderSectionProps {
    packages: GiftPackage[]
    deliveryTiers: DeliveryTier[]
    cities: City[]
}

const OrderSection: FC<OrderSectionProps> = ({ packages, deliveryTiers, cities }): ReactNode => {
    return (
        <section id='porosit' className='relative bg-brand-cream'>
            <div className='container-page section-pad'>
                {ordersLive() ? (
                    <>
                        <FadeIn>
                            <CmsText
                                as='h2'
                                textKey='order.title'
                                className='font-display text-4xl font-extrabold text-neutral-900 md:text-5xl'
                            />

                            <CmsText as='p' textKey='order.subtitle' className='mt-3 max-w-xl text-base text-neutral-600' />

                            <hr className='mt-4 w-12 border-0 border-t-2 border-brand-yellow' />
                        </FadeIn>

                        <div className='mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12'>
                            <div className='lg:col-span-7'>
                                <OrderForm packages={packages} cities={cities} />
                            </div>

                            <div className='lg:col-span-5'>
                                <InfoCard deliveryTiers={deliveryTiers} />
                            </div>
                        </div>
                    </>
                ) : (
                    <OrderClosed />
                )}
            </div>
        </section>
    )
}

export default OrderSection
